/* ═══════════════════════════════════════════════════════════
   Wokiee Custom Modifications
   ─ Minimum Quantity Enforcement
   ─ Minimum Cart Value (AJAX + static)
   ═══════════════════════════════════════════════════════════ */

/* ── 1. Minimum Quantity + Variant Stock Aware Enforcement ─── */
(function () {
  function getBaseMinQty() {
    var min = parseInt(window.wokieeMinQty, 10);
    if (!min || isNaN(min) || min <= 1) return 1;
    return min;
  }

  function getVariantInventoryMap() {
    return window.wokieeVariantInventory || {};
  }

  function getSelectedVariantId() {
    var form =
      document.querySelector('.tt-product-single-info form[action="/cart/add"]') ||
      document.querySelector('form[action="/cart/add"]');

    if (!form) return null;

    var variantInput =
      form.querySelector('[name="id"]') ||
      document.querySelector('[name="id"]');

    if (!variantInput) return null;

    return String(variantInput.value || '');
  }

  function getSelectedVariantStock() {
    var variantId = getSelectedVariantId();
    var map = getVariantInventoryMap();

    if (!variantId || !map || typeof map[variantId] === 'undefined') {
      return null;
    }

    var stock = parseInt(map[variantId], 10);

    if (isNaN(stock)) return null;

    return stock;
  }

  function getEffectiveMinQty() {
    var baseMin = getBaseMinQty();
    var stock = getSelectedVariantStock();

    if (stock === null) {
      return {
        baseMin: baseMin,
        stock: null,
        effectiveMin: baseMin,
        soldOut: false
      };
    }

    if (stock <= 0) {
      return {
        baseMin: baseMin,
        stock: stock,
        effectiveMin: 0,
        soldOut: true
      };
    }

    return {
      baseMin: baseMin,
      stock: stock,
      effectiveMin: Math.min(baseMin, stock),
      soldOut: false
    };
  }

  function getQtyInput() {
    return document.querySelector('.tt-product-single-info .tt-input-counter input[name="quantity"]') ||
           document.querySelector('.tt-input-counter input[name="quantity"]');
  }

  function getCounter() {
    return document.querySelector('.tt-product-single-info .tt-input-counter') ||
           document.querySelector('.tt-input-counter');
  }

  function getAddToCartButton() {
    return document.querySelector('.tt-product-single-info .btn-addtocart') ||
           document.querySelector('.tt-product-single-info button[name="add"]') ||
           document.querySelector('.tt-product-single-info button[type="submit"]') ||
           document.querySelector('.btn-addtocart') ||
           document.querySelector('button[name="add"]') ||
           document.querySelector('button[type="submit"]');
  }

  function updateMinusState(input, min) {
    var counter = getCounter();
    if (!counter || !input) return;

    var minusBtn = counter.querySelector('.minus-btn');
    if (minusBtn) {
      var qty = parseInt(input.value, 10);
      var shouldBlock = isNaN(qty) || qty <= min;

      minusBtn.disabled = shouldBlock;
      minusBtn.style.opacity = shouldBlock ? '0.4' : '';
      minusBtn.style.pointerEvents = shouldBlock ? 'none' : 'auto';
      minusBtn.style.cursor = shouldBlock ? 'not-allowed' : '';
    }
  }

  function updatePlusState(input, stock) {
    var counter = getCounter();
    if (!counter || !input) return;

    var plusBtn = counter.querySelector('.plus-btn');
    if (plusBtn && stock !== null && stock > 0) {
      var qty = parseInt(input.value, 10);
      var shouldBlock = !isNaN(qty) && qty >= stock;

      plusBtn.disabled = shouldBlock;
      plusBtn.style.opacity = shouldBlock ? '0.4' : '';
      plusBtn.style.pointerEvents = shouldBlock ? 'none' : 'auto';
      plusBtn.style.cursor = shouldBlock ? 'not-allowed' : '';
    }
  }

  function setSoldOutState(isSoldOut) {
    var input = getQtyInput();
    var counter = getCounter();
    var btn = getAddToCartButton();

    if (input) {
      input.disabled = isSoldOut;
      input.style.opacity = isSoldOut ? '0.5' : '';
      input.style.pointerEvents = isSoldOut ? 'none' : '';
      if (isSoldOut) input.value = 0;
    }

    if (counter) {
      counter.style.opacity = isSoldOut ? '0.5' : '';
      counter.style.pointerEvents = isSoldOut ? 'none' : '';
    }

    if (btn) {
      if (isSoldOut) {
        btn.disabled = true;
        btn.setAttribute('disabled', 'disabled');
        btn.style.opacity = '0.5';
        btn.style.pointerEvents = 'none';
        if (!btn.dataset.wkOriginalText) {
          btn.dataset.wkOriginalText = btn.textContent;
        }
        btn.textContent = 'Sold Out';
      } else {
        btn.disabled = false;
        btn.removeAttribute('disabled');
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
        if (btn.dataset.wkOriginalText) {
          btn.textContent = btn.dataset.wkOriginalText;
        }
      }
    }
  }

  function showMinQtyError(form, min) {
    var existing = form.querySelector('.tt-min-qty-error');
    if (existing) existing.remove();

    var msg = document.createElement('p');
    msg.className = 'tt-min-qty-error';
    msg.style.cssText = 'color:#c0392b;font-size:13px;margin-top:10px;font-weight:600;';
    msg.textContent = 'Minimum order quantity for this item is ' + min + '. Please update your quantity.';

    var btn = form.querySelector('.btn-addtocart, button[name="add"], button[type="submit"]');
    if (btn) btn.insertAdjacentElement('afterend', msg);
    else form.appendChild(msg);
  }

  function enforceMinQty() {
    var rule = getEffectiveMinQty();
    var input = getQtyInput();
    if (!input) return;

    if (rule.soldOut) {
      setSoldOutState(true);
      return;
    }

    setSoldOutState(false);

    var min = rule.effectiveMin || 1;

    input.setAttribute('min', min);

    if (rule.stock !== null && rule.stock > 0) {
      input.setAttribute('max', rule.stock);
      input.setAttribute('size', rule.stock);
    }

    var current = parseInt(input.value, 10);

    if (isNaN(current) || current < min) {
      input.value = min;
    }

    if (rule.stock !== null && rule.stock > 0 && parseInt(input.value, 10) > rule.stock) {
      input.value = rule.stock;
    }

    updateMinusState(input, min);
    updatePlusState(input, rule.stock);

    var form = input.closest('form') ||
               document.querySelector('.tt-add-basket-obj') ||
               document.querySelector('form[action="/cart/add"]');

    if (form && form.dataset.wkMinQtyFormBound !== '1') {
      form.addEventListener('submit', function (e) {
        var currentRule = getEffectiveMinQty();
        var currentInput = getQtyInput();
        var qty = currentInput ? parseInt(currentInput.value, 10) : 0;

        if (currentRule.soldOut) {
          e.preventDefault();
          return false;
        }

        if (isNaN(qty) || qty < currentRule.effectiveMin) {
          e.preventDefault();
          showMinQtyError(this, currentRule.effectiveMin);
          return false;
        }

        if (currentRule.stock !== null && currentRule.stock > 0 && qty > currentRule.stock) {
          e.preventDefault();
          currentInput.value = currentRule.stock;
          showMinQtyError(this, currentRule.stock);
          return false;
        }
      });

      form.dataset.wkMinQtyFormBound = '1';
    }

    bindProductQtyEvents();
  }

  function bindProductQtyEvents() {
    var input = getQtyInput();
    var counter = getCounter();

    if (input && input.dataset.wkMinQtyBound !== '1') {
      ['change', 'blur', 'input'].forEach(function (evt) {
        input.addEventListener(evt, function () {
          enforceMinQty();
        });
      });

      input.dataset.wkMinQtyBound = '1';
    }

    if (counter && counter.dataset.wkCounterBound !== '1') {
      var plusBtn = counter.querySelector('.plus-btn');
      var minusBtn = counter.querySelector('.minus-btn');

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          setTimeout(enforceMinQty, 40);
        }, true);
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          setTimeout(enforceMinQty, 40);
        }, true);
      }

      counter.dataset.wkCounterBound = '1';
    }
  }

  function bindVariantChangeEvents() {
    if (document.body.dataset.wkVariantStockBound === '1') return;

    document.addEventListener('change', function (e) {
      if (
        e.target &&
        (
          e.target.name === 'id' ||
          e.target.closest('.tt-options-swatch') ||
          e.target.closest('.tt-wrapper')
        )
      ) {
        setTimeout(enforceMinQty, 80);
        setTimeout(enforceMinQty, 250);
        setTimeout(enforceMinQty, 600);
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (
        e.target &&
        (
          e.target.closest('.tt-options-swatch') ||
          e.target.closest('[data-value]') ||
          e.target.closest('[data-option]')
        )
      ) {
        setTimeout(enforceMinQty, 80);
        setTimeout(enforceMinQty, 250);
        setTimeout(enforceMinQty, 600);
      }
    }, true);

    document.body.dataset.wkVariantStockBound = '1';
  }

  function runMinQtyInit() {
    bindVariantChangeEvents();
    enforceMinQty();

    var tries = 0;
    var maxTries = 20;

    var timer = setInterval(function () {
      enforceMinQty();
      tries++;
      if (tries >= maxTries) {
        clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runMinQtyInit);
  } else {
    runMinQtyInit();
  }
})();

/* ── 1B. Collection Card Minimum Quantity + Variant Stock Fix ─ */
(function () {
  function lvGetProductCard(el) {
    return el ? el.closest('.tt-product.product-parent, .tt-product') : null;
  }

  function lvGetCardForm(card) {
    return card ? card.querySelector('.lv-card-quick-order') : null;
  }

  function lvGetCardQtyInput(form) {
    return form ? form.querySelector('.lv-card-qty-input, input[name="quantity"]') : null;
  }

  function lvGetCardVariantInput(form) {
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function lvGetCardButton(form) {
    return form ? form.querySelector('.lv-card-add-btn, button[type="submit"]') : null;
  }

  function lvNormalizeStock(rawStock) {
    if (rawStock === null || typeof rawStock === 'undefined' || rawStock === '') {
      return null;
    }

    var stock = parseInt(rawStock, 10);
    if (isNaN(stock)) return null;

    return stock;
  }

  function lvApplyCardQtyRule(card, variantId, stock) {
    var form = lvGetCardForm(card);
    if (!form) return;

    var qtyInput = lvGetCardQtyInput(form);
    var variantInput = lvGetCardVariantInput(form);
    var btn = lvGetCardButton(form);

    if (!qtyInput || !variantInput || !btn) return;

    var baseMin = parseInt(form.getAttribute('data-lv-min-qty') || '1', 10);
    if (isNaN(baseMin) || baseMin < 1) baseMin = 1;

    stock = lvNormalizeStock(stock);

    if (variantId) {
      variantInput.value = variantId;
    }

    if (stock !== null) {
      form.setAttribute('data-lv-current-stock', stock);
    } else {
      stock = lvNormalizeStock(form.getAttribute('data-lv-current-stock'));
    }

    if (stock !== null && stock <= 0) {
      qtyInput.value = 0;
      qtyInput.setAttribute('min', 0);
      qtyInput.setAttribute('max', 0);
      qtyInput.disabled = true;

      btn.disabled = true;
      btn.setAttribute('disabled', 'disabled');
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';

      if (!btn.dataset.lvOriginalText) {
        btn.dataset.lvOriginalText = btn.textContent;
      }

      btn.textContent = 'Sold Out';
      return;
    }

    qtyInput.disabled = false;

    btn.disabled = false;
    btn.removeAttribute('disabled');
    btn.style.opacity = '';
    btn.style.pointerEvents = '';

    if (btn.dataset.lvOriginalText) {
      btn.textContent = btn.dataset.lvOriginalText;
    }

    var effectiveQty = baseMin;

    if (stock !== null && stock > 0 && stock < baseMin) {
      effectiveQty = stock;
    }

    qtyInput.setAttribute('min', effectiveQty);

    if (stock !== null && stock > 0 && stock !== 999999) {
      qtyInput.setAttribute('max', stock);
    } else {
      qtyInput.removeAttribute('max');
    }

    qtyInput.value = effectiveQty;
  }

  function lvFindActiveCardSwatch(card) {
    if (!card) return null;

    return card.querySelector('.tt-options-swatch li.active[data-var_id]') ||
           card.querySelector('.tt-option-block option:checked[data-var_id]');
  }

  function lvRefreshCardFromActiveSwatch(card) {
    var swatch = lvFindActiveCardSwatch(card);
    if (!swatch) return;

    lvApplyCardQtyRule(
      card,
      swatch.getAttribute('data-var_id'),
      swatch.getAttribute('data-inventory_qty')
    );
  }

  function lvBindCollectionCards() {
    document.querySelectorAll('.lv-card-quick-order').forEach(function (form) {
      if (form.dataset.lvCardBound === '1') return;

      var card = lvGetProductCard(form);
      var qtyInput = lvGetCardQtyInput(form);

      if (qtyInput) {
                ['input', 'change', 'blur'].forEach(function (evt) {
          qtyInput.addEventListener(evt, function () {
          var baseMin = parseInt(form.getAttribute('data-lv-min-qty') || '1', 10);
          var stock = lvNormalizeStock(form.getAttribute('data-lv-current-stock'));
          var val = parseInt(qtyInput.value, 10);

          if (isNaN(baseMin) || baseMin < 1) baseMin = 1;

          var effectiveQty = baseMin;

          if (stock !== null && stock > 0 && stock < baseMin) {
            effectiveQty = stock;
          }

          if (isNaN(val) || val < effectiveQty) {
            qtyInput.value = effectiveQty;
          }

                    if (stock !== null && stock > 0 && stock !== 999999 && parseInt(qtyInput.value, 10) > stock) {
            qtyInput.value = stock;
          }
        });
        });
      }

      if (card) {
        setTimeout(function () {
          lvRefreshCardFromActiveSwatch(card);
        }, 100);
      }

      form.dataset.lvCardBound = '1';
    });
  }

  function lvHandleCardSwatchSelection(e) {
    var swatch = e.target.closest('.tt-options-swatch li[data-var_id]');
    if (!swatch) return;

    var card = lvGetProductCard(swatch);
    if (!card) return;

    var variantId = swatch.getAttribute('data-var_id');
    var stock = swatch.getAttribute('data-inventory_qty');

    /*
      Run immediately to prevent Wokiee's built-in swatch script
      from briefly showing the wrong number in the quantity field.
    */
    lvApplyCardQtyRule(card, variantId, stock);

    setTimeout(function () {
      lvApplyCardQtyRule(card, variantId, stock);
    }, 20);

    setTimeout(function () {
      lvApplyCardQtyRule(card, variantId, stock);
    }, 80);

    setTimeout(function () {
      lvApplyCardQtyRule(card, variantId, stock);
    }, 250);

    setTimeout(function () {
      lvApplyCardQtyRule(card, variantId, stock);
    }, 600);
  }

  document.addEventListener('pointerdown', lvHandleCardSwatchSelection, true);
  document.addEventListener('mousedown', lvHandleCardSwatchSelection, true);
  document.addEventListener('touchstart', lvHandleCardSwatchSelection, true);
  document.addEventListener('click', lvHandleCardSwatchSelection, true);

  document.addEventListener('change', function (e) {
    var option = e.target && e.target.matches('.tt-option-block select') ? e.target.options[e.target.selectedIndex] : null;
    if (!option || !option.getAttribute('data-var_id')) return;

    var card = lvGetProductCard(e.target);
    if (!card) return;

    setTimeout(function () {
      lvApplyCardQtyRule(
        card,
        option.getAttribute('data-var_id'),
        option.getAttribute('data-inventory_qty')
      );
    }, 80);

    setTimeout(function () {
      lvApplyCardQtyRule(
        card,
        option.getAttribute('data-var_id'),
        option.getAttribute('data-inventory_qty')
      );
    }, 250);
  }, true);

  function lvInitCollectionCardQtyFix() {
    lvBindCollectionCards();

    var tries = 0;
    var timer = setInterval(function () {
      lvBindCollectionCards();
      tries++;
      if (tries >= 15) clearInterval(timer);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lvInitCollectionCardQtyFix);
  } else {
    lvInitCollectionCardQtyFix();
  }
})();

/* ── 2. Minimum Cart Value (AJAX drawer + static cart page) ── */
function wkFormatMoneyFromCents(cents) {
  var dollars = cents / 100;
  if (dollars % 1 === 0) {
    return '$' + dollars.toFixed(0);
  }
  return '$' + dollars.toFixed(2);
}

function wkCheckoutGuardToCart(e) {
  e.preventDefault();
  window.location.href = '/cart';
}

function wkToggleCheckoutControl(el, belowMinimum) {
  var isLink = el.tagName && el.tagName.toLowerCase() === 'a';

  if (isLink) {
    if (!el.dataset.wkOriginalHref) {
      el.dataset.wkOriginalHref = el.getAttribute('href') || '/checkout';
    }

    if (belowMinimum) {
      el.setAttribute('href', '/cart');
      el.setAttribute('aria-disabled', 'true');
      el.style.opacity = '0.5';
      el.style.pointerEvents = 'auto';

      if (!el.dataset.wkGuardBound) {
        el.addEventListener('click', wkCheckoutGuardToCart);
        el.dataset.wkGuardBound = '1';
      }
    } else {
      el.setAttribute('href', el.dataset.wkOriginalHref);
      el.removeAttribute('aria-disabled');
      el.style.opacity = '';
      el.style.pointerEvents = '';

      if (el.dataset.wkGuardBound) {
        el.removeEventListener('click', wkCheckoutGuardToCart);
        el.removeAttribute('data-wk-guard-bound');
      }
    }
  } else {
    if (belowMinimum) {
      el.setAttribute('disabled', 'disabled');
      el.style.opacity = '0.5';
      el.style.pointerEvents = 'none';
    } else {
      el.removeAttribute('disabled');
      el.style.opacity = '';
      el.style.pointerEvents = '';
    }
  }
}

function wkGetIncentiveBox() {
  return document.getElementById('wk-cart-incentives');
}

function wkGetIncentiveConfig() {
  var box = wkGetIncentiveBox();
  if (!box) return null;

  var tiers = [];

  if (box.dataset.tier1Enabled === 'true') {
    tiers.push({
      threshold: parseInt(box.dataset.tier1Threshold || '0', 10),
      label: box.dataset.tier1Label || ''
    });
  }

  if (box.dataset.tier2Enabled === 'true') {
    tiers.push({
      threshold: parseInt(box.dataset.tier2Threshold || '0', 10),
      label: box.dataset.tier2Label || ''
    });
  }

  if (box.dataset.tier3Enabled === 'true') {
    tiers.push({
      threshold: parseInt(box.dataset.tier3Threshold || '0', 10),
      label: box.dataset.tier3Label || ''
    });
  }

  tiers = tiers.filter(function (tier) {
    return tier.threshold > 0 && tier.label;
  }).sort(function (a, b) {
    return a.threshold - b.threshold;
  });

  return {
    box: box,
    minCartCents: parseInt(box.dataset.minCartCents || '0', 10),
    progressEnabled: box.dataset.progressEnabled === 'true',
    tiers: tiers
  };
}

function wkRenderCartIncentives(cartTotalCents) {
  var config = wkGetIncentiveConfig();
  if (!config) return;

  var box = config.box;
  var minNotice = box.querySelector('.wk-cart-incentives__notice--minimum');
  var rewardNotice = box.querySelector('.wk-cart-incentives__notice--reward');
  var progressWrap = box.querySelector('.wk-cart-incentives__progress');
  var progressFill = box.querySelector('.wk-cart-incentives__fill');
  var progressCaption = box.querySelector('.wk-cart-incentives__caption');

  if (minNotice) {
    minNotice.style.display = 'none';
    minNotice.innerHTML = '';
  }
  if (rewardNotice) {
    rewardNotice.style.display = 'none';
    rewardNotice.innerHTML = '';
  }
  if (progressWrap) {
    progressWrap.style.display = 'none';
  }
  if (progressFill) {
    progressFill.style.width = '0%';
  }
  if (progressCaption) {
    progressCaption.innerHTML = '';
  }

  if (config.minCartCents > 0 && cartTotalCents < config.minCartCents && minNotice) {
    var minRemaining = config.minCartCents - cartTotalCents;
    minNotice.innerHTML = 'Add <strong>' + wkFormatMoneyFromCents(minRemaining) + '</strong> more to reach the minimum order of <strong>' + wkFormatMoneyFromCents(config.minCartCents) + '</strong>.';
    minNotice.style.display = 'block';
  }

  if (config.tiers.length) {
    var unlockedTier = null;
    var nextTier = null;

    for (var i = 0; i < config.tiers.length; i++) {
      if (cartTotalCents >= config.tiers[i].threshold) {
        unlockedTier = config.tiers[i];
      } else {
        nextTier = config.tiers[i];
        break;
      }
    }

    if (rewardNotice) {
      if (!unlockedTier && nextTier) {
        rewardNotice.innerHTML = 'Add <strong>' + wkFormatMoneyFromCents(nextTier.threshold - cartTotalCents) + '</strong> more for the next reward.';
        rewardNotice.style.display = 'block';
      } else if (unlockedTier && nextTier) {
        rewardNotice.innerHTML = '<strong>' + unlockedTier.label + '</strong><br><span class="wk-cart-incentives__subline">Add <strong>' + wkFormatMoneyFromCents(nextTier.threshold - cartTotalCents) + '</strong> more for the next reward.</span>';
        rewardNotice.style.display = 'block';
      } else if (unlockedTier && !nextTier) {
        rewardNotice.innerHTML = '<strong>' + unlockedTier.label + '</strong>';
        rewardNotice.style.display = 'block';
      }
    }

    if (config.progressEnabled && progressWrap && progressFill && progressCaption) {
      var finalTier = config.tiers[config.tiers.length - 1];
      var percent = Math.max(0, Math.min(100, (cartTotalCents / finalTier.threshold) * 100));

      progressFill.style.width = percent + '%';
      progressWrap.style.display = 'block';

      if (cartTotalCents >= finalTier.threshold) {
        progressCaption.innerHTML = 'Free shipping is ready on this order.';
      } else {
        progressCaption.innerHTML = 'Add <strong>' + wkFormatMoneyFromCents(finalTier.threshold - cartTotalCents) + '</strong> more for free shipping.';
      }
    }
  }
}

function wokieeCheckMinCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var incentiveConfig = wkGetIncentiveConfig();
      var minCents = 0;

      if (incentiveConfig && incentiveConfig.minCartCents > 0) {
        minCents = incentiveConfig.minCartCents;
      } else {
        minCents = parseInt(
          document.body.getAttribute('data-min-cart-cents') || '0', 10
        );
      }

      document.querySelectorAll('.tt-cart-min-notice-dynamic').forEach(function (el) {
        el.remove();
      });

      var controls = document.querySelectorAll(
        '[name="checkout"], a[href="/checkout"], a[href*="/checkout?"]'
      );

      var belowMinimum = minCents > 0 && cart.total_price < minCents;

      controls.forEach(function (el) {
        wkToggleCheckoutControl(el, belowMinimum);
      });

      if (incentiveConfig) {
        wkRenderCartIncentives(cart.total_price);
      } else if (belowMinimum) {
        var remainingCents = minCents - cart.total_price;
        var remainingText = wkFormatMoneyFromCents(remainingCents);
        var minimumText = wkFormatMoneyFromCents(minCents);

        controls.forEach(function (el) {
          var parent = el.parentNode;
          if (!parent) return;

          var notice = document.createElement('p');
          notice.className = 'tt-cart-min-notice-dynamic';
          notice.style.cssText = [
            'background:#fff8e1',
            'border-left:3px solid #ffc107',
            'border-radius:3px',
            'padding:10px 14px',
            'margin-bottom:12px',
            'color:#856404',
            'font-size:13px',
            'font-weight:500'
          ].join(';');
          notice.textContent = 'Add ' + remainingText + ' more to reach the minimum order of ' + minimumText + '.';

          parent.insertBefore(notice, el);
        });
      }
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wokieeCheckMinCart);
} else {
  wokieeCheckMinCart();
}

/* Fallback: re-check cart minimum whenever Wokiee updates the cart UI */
(function () {
  var cartTarget = document.querySelector('.tt-cart-holder, .tt-cart-bootstrap, #tt-pageContent');
  if (!cartTarget) return;
  var observer = new MutationObserver(function () {
    wokieeCheckMinCart();
  });
  observer.observe(cartTarget, { childList: true, subtree: true });
})();

/* ── 3. Cart Line Minimum Quantity Enforcement ─────────────── */
(function () {
  function wkClampCartQtyInput(input) {
    if (!input) return;

    var min = Number(input.getAttribute('data-min-qty')) || Number(input.getAttribute('min')) || 1;
    var val = Number(input.value);

    if (isNaN(val) || val < min) {
      input.value = min;
      val = min;
    }

    var counter = input.closest('.tt-input-counter');
    if (counter) {
      var minusBtn = counter.querySelector('.minus-btn');
      var plusBtn = counter.querySelector('.plus-btn');
      var max = Number(input.getAttribute('size')) || 999999;

      if (minusBtn) {
        if (val <= min) {
          minusBtn.style.display = 'none';
          minusBtn.style.pointerEvents = 'none';
          minusBtn.style.opacity = '0.4';
        } else {
          minusBtn.style.display = '';
          minusBtn.style.pointerEvents = 'auto';
          minusBtn.style.opacity = '';
        }
      }

      if (plusBtn) {
        if (val >= max) {
          plusBtn.style.display = 'none';
        } else {
          plusBtn.style.display = '';
        }
      }
    }
  }

  function wkBindCartQtyGuards() {
    var inputs = document.querySelectorAll('.tt-shopcart-table--js input[name="updates[]"]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      if (input.dataset.wkCartQtyBound === '1') {
        wkClampCartQtyInput(input);
        return;
      }

      ['input', 'change', 'blur'].forEach(function (evt) {
        input.addEventListener(evt, function () {
          wkClampCartQtyInput(input);
        });
      });

      var counter = input.closest('.tt-input-counter');
      if (counter) {
        var minusBtn = counter.querySelector('.minus-btn');
        var plusBtn = counter.querySelector('.plus-btn');

        if (minusBtn) {
          minusBtn.addEventListener('click', function (e) {
            var min = Number(input.getAttribute('data-min-qty')) || Number(input.getAttribute('min')) || 1;
            var val = Number(input.value);

            if (isNaN(val) || val <= min) {
              e.preventDefault();
              e.stopPropagation();
              input.value = min;
              wkClampCartQtyInput(input);
              return false;
            }

            setTimeout(function () {
              wkClampCartQtyInput(input);
            }, 30);
          }, true);
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', function () {
            setTimeout(function () {
              wkClampCartQtyInput(input);
            }, 30);
          }, true);
        }
      }

      input.dataset.wkCartQtyBound = '1';
      wkClampCartQtyInput(input);
    });
  }

  function wkInitCartQtyGuards() {
    wkBindCartQtyGuards();

    var tries = 0;
    var maxTries = 15;
    var timer = setInterval(function () {
      wkBindCartQtyGuards();
      tries++;
      if (tries >= maxTries) clearInterval(timer);
    }, 300);

    var cartTable = document.querySelector('.tt-shopcart-table--js') || document.querySelector('#tt-pageContent');
    if (!cartTable || cartTable.dataset.wkCartObserverBound === '1') return;

    var observer = new MutationObserver(function () {
      wkBindCartQtyGuards();
    });

    observer.observe(cartTable, { childList: true, subtree: true });
    cartTable.dataset.wkCartObserverBound = '1';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wkInitCartQtyGuards);
  } else {
    wkInitCartQtyGuards();
  }
})();

/* =========================================================
   Section 1C: Wholesale Price Leak Protection on Variant Click
   Purpose:
   Prevent Wokiee variant swatches from revealing product prices
   to customers who are not allowed to see wholesale pricing.
   ========================================================= */

(function () {
  function lvWholesalePriceIsLocked() {
    var bodyText = document.body ? document.body.innerText : '';

    return (
      bodyText.indexOf('Log in to see price') !== -1 ||
      bodyText.indexOf('Log in to purchase') !== -1
    );
  }

  function lvLockVisiblePrices() {
    if (!lvWholesalePriceIsLocked()) return;

    var priceSelectors = [
      '.tt-price',
      '.tt-product .tt-price',
      '.tt-product-inside-hover .tt-price',
      '.tt-product-single-info .tt-price',
      '.price',
      '.product-price'
    ];

    document.querySelectorAll(priceSelectors.join(',')).forEach(function (priceBox) {
      if (!priceBox) return;

      var text = priceBox.innerText || '';

      var looksLikePrice =
        text.indexOf('$') !== -1 ||
        /\d+\.\d{2}/.test(text) ||
        text.toLowerCase().indexOf('sale') !== -1;

      var alreadyLocked =
        text.indexOf('Log in to see price') !== -1 ||
        text.indexOf('Log in to purchase') !== -1;

      if (looksLikePrice && !alreadyLocked) {
        priceBox.innerHTML = '<span class="lv-login-price-text">Log in to see price</span>';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    lvLockVisiblePrices();

    document.body.addEventListener(
      'click',
      function () {
        setTimeout(lvLockVisiblePrices, 0);
        setTimeout(lvLockVisiblePrices, 100);
        setTimeout(lvLockVisiblePrices, 300);
        setTimeout(lvLockVisiblePrices, 700);
      },
      true
    );

    var observer = new MutationObserver(function () {
      lvLockVisiblePrices();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();